/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  TradePreClearanceApprovalService,
  type Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '@wealthlane/api-services/wealthlane-award-service';

interface ApprovalPayload {
  tradePreClearanceRequestId: string;
  description: string;
  file: File;
}

const usePostPreClearanceRequestApprove = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeConfirmModal: () => void,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined,
  unknown,
  ApprovalPayload,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: ApprovalPayload) => {
      return await handleRequest(
        TradePreClearanceApprovalService.postApiAwardApiAppTradePreClearanceApprovalApprovePreClearanceRequest({
          TradePreClearanceRequestId: payload.tradePreClearanceRequestId,
          Description: payload.description,
          File: payload.file,
        })
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getPreClearanceRequestList');
          closeConfirmModal();
          closeModal();
          toast.success(<ToastComponent label='Success' message='Pre Clearance Approved.' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostPreClearanceRequestApprove;
